/**
 * Returns true if the given seed value should be treated as "unseeded".
 * A team is considered unseeded when its seed is -1, 0, null, or undefined.
 */
export default function isUnseededTeam(seed: number | null | undefined): boolean {
  return seed == null || seed === -1 || seed === 0;
}
